import { useQuery } from "react-query";
import LogRocket from "logrocket";

const environmentMap = {
  "localhost:3000": "local",
  "traffix-highland-stage.azurewebsites.net": "staging",
  "highland.traffix.com": "production",
  "traffix-highland.azurewebsites.net": "production",
};

export default function useUserData() {
  const { data, isLoading } = useQuery("userData", () => {
    const userId = localStorage.getItem("userId");
    const username = localStorage.getItem("username");
    const type = localStorage.getItem("type");
    const location = localStorage.getItem("location");
    const host = window.location.host;
    if (type && location) {
      LogRocket.identify(userId, {
        name: username,
        type: type,
        location: location,
        env: environmentMap[host],
      });
      return { type, location };
    } else {
      localStorage.clear();
      return null;
    }
  });

  return { data, isLoading };
}
